import { SET_SYSTEM_ALERT } from "./action";

export const defaultState = {
  systemAlert: "undefined",
};

function SystemAlertReducer(state = defaultState, action) {
  switch (action.type) {
    case SET_SYSTEM_ALERT:
      return {
        ...state,
        systemAlert: action.payload,
      };
    default:
      return state;
  }
}

export default SystemAlertReducer;
